module.exports = __webpack_public_path__ + "img/recessionproofcapital-white-text-only-powered.2c9d3f33.png";